export const REGIONS = [
    { key: "FRONTAL", label: "Frontal" },
    { key: "VERTEX", label: "Vértex" },
    { key: "PARIETAL_R", label: "Parietal Direita" },
    { key: "PARIETAL_L", label: "Parietal Esquerda" },
    { key: "TEMPORAL_R", label: "Temporal Direita" },
    { key: "TEMPORAL_L", label: "Temporal Esquerda" },
    { key: "OCCIPITAL", label: "Occipital (controle)" },
    { key: "OTHER", label: "Outra" },
  ];
  
  export const MARK_TYPES = [
    { key: "SINGLE", label: "Simples" },
    { key: "DOUBLE", label: "Duplos" },
    { key: "TRIPLE", label: "Triplos" },
    { key: "OSTIUM", label: "Óstios" },
  ];
  
  export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  
  export const uid = (prefix = "") =>
    `${prefix}${Math.random().toString(16).slice(2)}${Date.now().toString(16)}`;
  
  export function normalizeRect(rect) {
    const x = Number(rect.x || 0);
    const y = Number(rect.y || 0);
    const w = Number(rect.w || 0);
    const h = Number(rect.h || 0);
    return { x, y, w, h };
  }
  
  export function safePct(num, den) {
    if (!den || den <= 0) return 0;
    return Math.round((num * 100) / den);
  }
  
  export function buildSummary({ counts, areaCm2, compareControl, controlCounts }) {
    const singles = counts.SINGLE || 0;
    const doubles = counts.DOUBLE || 0;
    const triples = counts.TRIPLE || 0;
  
    const totalUF = singles + doubles + triples;
    const totalFios = singles * 1 + doubles * 2 + triples * 3;
  
    const pctSingles = safePct(singles, totalUF);
    const pctDoubles = safePct(doubles, totalUF);
    const pctTriples = safePct(triples, totalUF);
  
    // densidade se houver calibração de área (opcional)
    const densityUF = areaCm2 ? Math.round(totalUF / areaCm2) : null;
  
    // heurística (simples, ajustável)
    // mais simples + pouca dupla/tripla => sinal indireto de afinamento
    let riskScore = 0;
    if (pctSingles >= 60) riskScore += 1;
    if (totalUF > 0 && (doubles + triples) === 0) riskScore += 1;
    if (densityUF != null && densityUF < 25) riskScore += 1;
  
    let severity = { variant: "success", label: "Padrão ok" };
    if (riskScore === 2) severity = { variant: "warning", label: "Atenção" };
    if (riskScore >= 3) severity = { variant: "danger", label: "Alto risco" };
  
    // comparação com controle (se você quiser evoluir depois)
    const control = controlCounts ? (controlCounts.SINGLE || 0) + (controlCounts.DOUBLE || 0) + (controlCounts.TRIPLE || 0) : null;
    const densityVsControl = compareControl && control ? null : null;
  
    return {
      totalUF,
      totalFios,
      pctSingles,
      pctDoubles,
      pctTriples,
      densityUF,
      densityVsControl,
      severity,
    };
  }
  